export default "24e8fc6e411bf2ea.svg"